<script setup>
import HrTabPanel from './HrTabPanel.vue';

/**
 * A single pane within HrPanels, shown when its name matches the active one.
 *
 * @status recommended
 * @group navigation
 * @useWhen Providing one pane of a programmatically switched set
 * @within hr-panels
 * @related HrTabPanel
 * @a11y Announces as ordinary content. Quasar marks its panels `role="tabpanel"`, which with no tab
 * bar above them sends a screen reader looking for tabs that do not exist.
 */
defineOptions({ name: 'HrPanel' });

defineProps({
  /**
   * Identifier matched against the value HrPanels is bound to. Required.
   * @example editor
   */
  name: {
    type: [String, Number],
    required: true,
  },
});
</script>

<template>
  <hr-tab-panel
    v-bind="$props"
    role="presentation"
  >
    <!-- @slot Panel content. -->
    <slot />
  </hr-tab-panel>
</template>
